"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.new.title': 'Add New Knowledge',
    'shortcuts.new.description': 'Create or add new knowledge to the system',
};
